import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { removeAppModalInRedux } from "../global/globalSlice";
import { useAppDispatch, useAppSelector } from "../hooks";
import { AppModalEnums } from "../mc-shared/sharedConstants";
import IssueItemModalMantine from "./routes/issuesApp/IssuesTab/IssueItemModal/new/IssueItemModalMantine";
import MeetingSerieModal from "./routes/projectdashboard/MeetingSeries/MeetingSerieModal";

const OpenedAppModals: React.FC = () => {
  const openedAppModals = useAppSelector((state) => state.globalReducer.openedAppModals);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlId = searchParams.get("id");

    if (openedAppModals.length > 0 && urlId == null) {
      // Browser navigated away (Back/Forward) — clear all modals from Redux only
      openedAppModals.forEach((modal) => {
        dispatch(removeAppModalInRedux(modal.itemId));
      });
    }
  }, [location.search]);

  const topModal = openedAppModals.length > 0 ? openedAppModals[openedAppModals.length - 1] : null;

  if (topModal == null) return null;

  const replaceIssueIdUrlParam = (itemId?: string) => {
    const searchParams = new URLSearchParams(location.search);
    if (itemId != null) {
      searchParams.set("id", itemId);
    } else {
      searchParams.delete("id");
    }

    const search = searchParams.toString();
    history.replace({
      pathname: location.pathname,
      search: search ? `?${search}` : "",
    });
  };

  const handleClose = (itemId: string) => {
    // After removal, the new top is the second-to-last in the current array
    const newTop = openedAppModals.length > 1 ? openedAppModals[openedAppModals.length - 2] : null;
    replaceIssueIdUrlParam(newTop?.itemId);
    dispatch(removeAppModalInRedux(itemId));
  };

  return (
    <div key={topModal.itemId}>
      {(topModal.app === AppModalEnums.ISSUE || topModal.app === AppModalEnums.ISSUE_MANTINE) &&
        topModal.boardId != null && (
          <IssueItemModalMantine
            onClose={() => handleClose(topModal.itemId)}
            itemId={topModal.itemId}
            issueBoardId={topModal.boardId}
            projectId={topModal.projectId}
          />
        )}
      {topModal.app === AppModalEnums.MEETING_SERIE && (
        <MeetingSerieModal
          projectId={topModal.projectId}
          meetingSerieId={topModal.itemId}
          toggle={() => handleClose(topModal.itemId)}
          startIsoString={topModal.startIsoString}
        />
      )}
    </div>
  );
};

export default OpenedAppModals;
